import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';

import HitCard from 'Components/Cards/HitCard';
import { fetchTopSellers, query } from 'Redux/ducks/algolia-calls';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';

const BlogProductsContainer = ({
  lgSize,
  searchTerm,
  existingHits,
  hitCardLightTheme,
  hitCardNameTag,
}) => {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const loadTopSellers = async () => {
      const fetchedHits = await fetchTopSellers('all', 3);
      return setHits(fetchedHits.hits);
    };

    const loadRelatedPosts = async () => {
      if (!searchTerm) return false;
      const fetchedHits = await query(searchTerm, 3);
      return setHits(fetchedHits);
    };

    if (existingHits && existingHits.length) {
      setHits(existingHits);
    } else if (searchTerm) {
      loadRelatedPosts();
    } else {
      loadTopSellers();
    }
  }, [searchTerm, existingHits]);

  return (
    <Row>
      {isEmpty(hits) &&
        <SkeletonHitCard
          numberOfCards={3}
          lgSize={lgSize}
          mdSize={4}
          smSize={4}
          xsSize={12}
        />
      }
      {hits.map(hit =>
        <HitCard
          hitCardLightTheme={hitCardLightTheme}
          key={Math.random() + hit}
          hit={hit}
          lgSize={lgSize}
          mdSize={4}
          smSize={4}
          xsSize={12}
          hitCardNameTag={hitCardNameTag}
        />,
      )}
    </Row>
  );
};

BlogProductsContainer.propTypes = {
  searchTerm: PropTypes.string,
  lgSize: PropTypes.number,
  existingHits: PropTypes.arrayOf(PropTypes.shape({})),
  hitCardLightTheme: PropTypes.bool,
  hitCardNameTag: PropTypes.string,
};

BlogProductsContainer.defaultProps = {
  searchTerm: '',
  lgSize: 12,
  existingHits: [],
  hitCardLightTheme: false,
  hitCardNameTag: 'div',
};


export default BlogProductsContainer;
